<ui-card>
  <section class="ui-form-section" [attr.data-variant]="variant()">
    <header class="ui-form-section__header">
      <div>
        <h2 class="ui-form-section__title">{{ title() | uiLabelTranslate }}</h2>
        @if (description()) {
          <p class="ui-form-section__description">{{ description() | uiLabelTranslate }}</p>
        }
      </div>
    </header>

    <div class="ui-form-section__content">
      <ng-content />
    </div>
  </section>
</ui-card>
